import { label } from "motion/react-client";
import { title } from "process";

export const widgetLegends = {
  // BARRA SUPERIOR
  stationSelect: {
    title: {
      ca: "Menú selector d'estacions"
    }
  },
  homeButton: {
    title: {
      ca: "Botó d'accés directe a l'escriptori d'estacions"
    }
  },
  tonalitySelect: {
    title: {
      ca: "Selector de la tonalitat de la cançó"
    }
  },
  transportMetronome: {
    title: {
      ca: "Metrònom"
    }
  },
  transportTempoBox: {
    title: {
      ca: "Control de tempo"
    },
    description: {
      ca: "Representat en BPMs (beats per minut) ens permet modificar la velocitat de la cançó."
    }
  },
  transportSwingBox: {
    title: {
      ca: "Control de swing"
    },
    description: {
      ca: "El swing és una característica rítmica que dóna a la música una sensació de moviment orgànic. Desplaça els cops entre temps i els fa més humans i menys rígids."
    }
  },
  transportPlayToggle: {
    title: {
      ca: "Play/Stop"
    },
    description: {
      ca: "Aquest conmutador permet iniciar o aturar la reproducció del Gruf."
    }
  },
  transportMidiRecordToggle: {
    title: {
      ca: "Gravació"
    },
    description: {
      ca: "Aquest botó permet activar la gravació de notes en directe des d'un teclat o dispositiu midi."
    }
  },
  muteToggle: {
    title: {
      ca: "Mute"
    },
    description: {
      ca: "Aquest botó permet silenciar l'instrument a on et trobes."
    }
  },
  soloToggle: {
    title: {
      ca: "Solo"
    },
    description: {
      ca: "Serveix per escoltar només l'instrument on et trobes (La resta queden silenciades fins que el tornes a clicar)."
    }
  },
  projectTitle: {
    title: {
      ca: "Títol del projecte"
    }
  },
  connectedUsers: {
    title: {
      ca: "Número d'usuaris connectats en aquest moment al projecte"
    }
  },
  configurationTrigger: {
    title: {
      ca: "Accés a la configuració"
    }
  },
  exitButton: {
    title: {
      ca: "Sortir del projecte"
    }
  },
  // ELEMENTS COMUNS ALS INSTRUMENTS
  presetSelect: {
    title: {
      ca: "Selector de sons"
    },
    description: {
      ca: "Des d'aquí podràs accedir a diferents configuracions de so predeterminades i als presets que has guardat."
    }
  },
  presetMenuTrigger: {
    title: {
      ca: "Accions del preset"
    },
    description: {
      ca: "Des d'aquest menú pots exportar, reanomenar i/o eliminar presets. També pots tornar a carregar els valors per defecte de l'instrument."
    }
  },
  presetSaveButton: {
    title: {
      ca: "Botó de guardar"
    },
    description: {
      ca: "Permet guardar la configuració del so que tens actualment."
    },
  },
  instrumentVolume: {
    label: {
      ca: "Vol"
    },
    title: {
      ca: "Volum"
    },
    description: {
      ca: "Aquesta roda modifica el volum (intensitat) d'aquest instrument. Aquest element està vinculat a la pista d'aquest instrument al Mixer."
    }
  },
  lpfCutoff: {
    label: {
      ca: "Cutoff"
    },
    title: {
      ca: "Cutoff"
    },
    description: {
      ca: "Aquesta roda és un filtre de freqüències. Si mous la posició del potenciòmetre cap a l’esquerra desapareixaran progressivament les freqüències mitges i agudes i ens quedarem amb les greus o subgreus."
    }
  },
  hpfCutoff: {
    label: {
      ca: "HPF"
    },
  },
  adsr: {
    label: {
      ca: "ADSR"
    },
    title: {
      ca: "ADSR"
    },
    description: {
      ca: "Dispositiu que modula el volum del so en el temps, amb els paràmetres d'Attack, Decay, Sustain i Release."
    }
  },
  adsrAttack: {
    label: {
      ca: "Attack"
    },
    title: {
      ca: "Attack"
    },
    description: {
      ca: "El paràmetre attack modifica com comença a reproduir-se el so. Pot començar més bruscament o més suau, depenent d'on col·loquis l'angle del potenciòmetre."
    }
  },
  adsrDecay: {
    label: {
      ca: "Decay"
    },
    title: {
      ca: "Decay"
    },
    description: {
      ca: "És el temps que tarda el so a baixar des del volum màxim fins al nivell de sosteniment. Serveix per fer que el so sigui més curt i sec o més llarg i suau."
    }
  },
  adsrSustain: {
    label: {
      ca: "Sustain"
    },
    title: {
      ca: "Sustain"
    },
    description: {
      ca: "El sustain és el nivell de volum que manté el so mentre tens la tecla premuda. Serveix per fer que el so sigui constant o s'apagui ràpid, segons la posició del potenciòmetre."
    },
  },
  adsrRelease: {
    label: {
      ca: "Release",
    },
    title: {
      ca: "Release",
    },
    description: {
      ca: "El release és el temps que tarda triga el so a desaparèixer quan deixes anar la tecla. Pot fer que el so s'acabi de cop o s'esvaeixi suaument."
    }
  },
  equalizer: {
    label: {
      ca: "Equalització"
    },
    title: {
      ca: "Equalitzador"
    },
    description: {
      ca: "Dispositiu per modificar els 3 rangs freqüencials de greus, mitjos i aguts. S'activa i desactiva amb la pestanya que hi ha a la part superior dreta del requadre."
    }
  },
  eqToggle: {
    title: {
      ca: "EQ On/Off"
    },
    description: {
      ca: "Activa o desactiva l'equalitzador."
    }
  },
  eqLow: {
    label: {
      ca: "Low"
    },
    title: {
      ca: "Rang greu"
    },
    description: {
      ca: "Augmenta o atenua la percepció del rang de freqüències greus."
    }
  },
  eqMid: {
    label: {
      ca: "Mid"
    },
    title: {
      ca: "Rang mig"
    },
    description: {
      ca: "Augmenta o atenua la percepció del rang de freqüències mitges."
    }
  },
  eqHigh: {
    label: {
      ca: "High"
    },
    title: {
      ca: "Rang agut"
    },
    description: {
      ca: "Augmenta o atenua la percepció del rang de freqüències agudes."
    }
  },
  sends: {
    label: {
      ca: "Sends"
    },
    title: {
      ca: "Sends"
    },
    description: {
      ca: "Dispositiu d'enviament de la senyal cap als 4 canals d'efectes: Reverb A i B, Delay A i B."
    }
  },
  sendReverbA: {
    label: {
      ca: "Reverb A"
    },
    title: {
      ca: "Reverb"
    },
    description: {
      ca: "Aplica un efecte al teu instrument per aconseguir ubicar el teu so en un espai més gran o més petit i poder controlar la proximitat i llunyania del so."
    }
  },
  sendReverbB: {
    label: {
      ca: "Reverb B"
    },
    title: {
      ca: "Reverb"
    },
    description: {
      ca: "Aplica un efecte al teu instrument per aconseguir ubicar el teu so en un espai més gran o més petit i poder controlar la proximitat i llunyania del so."
    }
  },
  sendDelayA: {
    label: {
      ca: "Delay A"
    },
    title: {
      ca: "Delay"
    },
    description: {
      ca: "Aplica un efecte d'espai al teu instrument a través de repeticions del mateix so, com un eco. Pots controlar la sensació de proximitat o llunyania."
    }
  },
  sendDelayB: {
    label: {
      ca: "Delay B"
    },
    title: {
      ca: "Delay"
    },
    description: {
      ca: "Aplica un efecte d'espai al teu instrument a través de repeticions del mateix so, com un eco. Pots controlar la sensació de proximitat o llunyania."
    }
  },
  helpBox: {
    title: {
      ca: "Caixa d'ajuda"
    }
  },
  pianoRoll: {
    title: {
      ca: "Editor de notes"
    },
    description: {
      ca: "Aquesta graella serveix per escriure, gravar i editar la posició i llargada de les notes musicals que sonaran dins d'aquest instrument."
    }
  },
  pianoRollDiatonicColoring: {
    title: {
      ca: "Visió diatònica"
    },
    description: {
      ca: "Aquest botó activa la visió diatònica. Significa que veus ressaltades les notes diatòniques de la tonalitat escollida de la cançó. De color violeta/vermell fosc la fonamental,  de color violeta/vermell clar  la resta de notes diatòniques i de color gris les notes que no ho són."
    }
  },
  pianoRollChromaticColoring: {
    title: {
      ca: "Visió cromàtica"
    },
    description: {
      ca: "Aquest botó activa la visió cromàtica. No es ressalten notes, es veuen com en un piano perquè tinguis una guia."
    }
  },
  clipMenuTrigger: {
    title: {
      ca: "Accions del clip"
    },
    description: {
      ca: "Menú desplegable que permet canviar altres coses del clip que no la durada."
    }
  },
  clipSelect: {
    title: {
      ca: "Banc de clips"
    },
    description: {
      ca: "A, B, C i D són 4 clips independents on pots escriure notes diferents i imprimir diferents efectes de so. S'utilitza per fer variacions, és a dir, per construir diferents parts d'una cançó."
    }
  },
  clipDurationControls: {
    title: {
      ca: "Canvi de durada del clip"
    },
    description: {
      ca: "Control per augmentar o reduir la durada en compassos del clip. Pots escollir entre 1, 2 o 4 compassos de durada."
    }
  },
  // ELEMENTS ESPECÍFICS, SYNTH I SYNTH BASS
  synthesis: {
    label: {
      ca: "Síntesi"
    },
    title: {
      ca: "Síntesi"
    },
    description: {
      ca: "Dispositiu que genera el so a través de l'oscil·lador i el modifica amb els paràmetres Detune, Glide, Mod Rate i Mod Depth."
    }
  },
  oscWaveform: {
    title: {
      ca: "Oscil·lador"
    },
    description: {
      ca: "Genera un so a partir d'una altura musical. Pots escollir 4 formes d'ona diferents: sinusoïdal, quadrada, triangular i de serra. Totes 4 amb unes qualitats tímbriques diferents."
    }
  },
  oscOctave: {
    label: {
      ca: "Octave"
    },
  },
  oscDetune: {
    label: {
      ca: "Detune"
    },
    title: {
      ca: "Detune"
    },
    description: {
      ca: "Vols un so més gruixut? Aquest paràmetre duplica la senyal, en desafina una de les còpies i aconsegueix aportar cos i amplitud. Com en tot, el secret està a aplicar-lo en la seva justa mesura!"
    }
  },
  oscPortamento: {
    label: {
      ca: "Glide"
    },
    title: {
      ca: "Glide"
    },
    description: {
      ca: "El glide (o portamento) converteix el teu sintetitzador en un tobogan musical. En lloc de fer un salt brusc entre una nota i una altra, el so viatja lliscant per totes les notes que hi ha pel mig. Si gires el potenciòmetre  al màxim, el viatge d'una nota a l'altra serà molt més lent i llarg!"
    }
  },
  lfoRate: {
    label: {
      ca: "Mod Rate"
    },
    title: {
      ca: "Velocitat de modulació"
    },
    description: {
      ca: "Juntament amb la profunditat de modulació, modula el volum del so (creant un efecte de trèmolo). La velocitat de modulació fa que el volum pugi i baixi de manera més lenta o ràpida."
    }
  },
  lfoDepth: {
    label: {
      ca: "Mod Depth"
    },
    title: {
      ca: "Profunditat de modulació"
    },
    description: {
      ca: "Juntament amb la velocitat de modulació, modula el volum del so (creant un efecte de trèmolo). La profunditat de modulació defineix com de marcat o intens serà el canvi de volum."
    }
  },
  // ELEMENTS ESPECÍFICS, PIANO
  pianoSound: {
    label: {
      ca: "So"
    }
  },
  pianoTimbre: {
    label: {
      ca: "Timbre"
    }
  },
  // ELEMENTS ESPECÍFICS, GROOVEBOX
  drumVol: {
    label: {
      ca: "Vol"
    },
    title: {
      ca: "Volum"
    },
    description: {
      ca: "Aquest potenciòmetre modifica el volum de l’element de la Groovebox seleccionat (Open hat, closed hat, snare o kick)."
    }
  },
  drumTone: {
    label: {
      ca: "Tone"
    },
    title: {
      ca: "Tone"
    },
    description: {
      ca: "Controla l'afinació de l’element seleccionat. Gira el potenciòmetre  per obtenir un cop més agut i definit o més greu i contundent."
    }
  },
  drumRelease: {
    label: {
      ca: "Release"
    },
    title: {
      ca: "Release"
    },
    description: {
      ca: "Regula la durada de la cua del so seleccionat."
    }
  },
  drumReverb: {
    label: {
      ca: "Reverb"
    },
    title: {
      ca: "Reverb"
    },
    description: {
      ca: "Aquest control simula l'acústica d'un espai. Com més gires el potenciòmetre, més gran es fa l'habitació on sona el so que has seleccionat. Des d'un espai petit i sec fins a una catedral gegant."
    }
  },
  drumSwing: {
    label: {
      ca: "Swing"
    },
    title: {
      ca: "Swing"
    },
    description: {
      ca: "Afegeix un retard a determinats cops de l’element que has seleccionat per trencar la rigidesa de la graella digital. Aporta un moviment rítmic més humà."
    }
  },
  drumDrumkit: {
    title: {
      ca: "Selector de mostres"
    },
    description: {
      ca: "Aquest control permet seleccionar entre diferents mostres de cada element de la Groovebox."
    }
  },
  drumPad: {
    title: {
      ca: "Pad de so"
    },
    description: {
      ca: "Cada pad reprodueix l'element corresponent de la bateria. Per exemple, si selecciones “snare” (la caixa), sonarà la caixa. A més podràs ajustar els seus paràmetres específics a l'esquerra: Vol, Tone, Release, Reverb i Swing."
    }
  },
  grooveboxSequencer: {
    title: {
      ca: "Seqüenciador"
    },
    description: {
      ca: "És el cervell de la Groovebox. Permet programar, ordenar i reproduir els cops en el temps per crear els teus patrons de bateria."
    }
  },
  // ELEMENTS ESPECÍFICS, SAMPLER
  sampleSelect: { // també a looper
    title: {
      ca: "Menú selector de samples"
    },
    description: {
      ca: "Des d'aquí podràs accedir les diferents mostres samples que hem preparat per utilitzar."
    }
  },
  choke: {
    label: {
      ca: "Choke"
    },
    title: {
      ca: "Choke"
    },
    description: {
      ca: "Activa o desactiva el Choke. La seva funció quan està activat és que interromp la reproducció d'un so quan se'n dispara un altre."
    }
  },
  padTranspose: {
    label: {
      ca: "Transpose"
    },
    title: {
      ca: "Transposició del pad"
    },
    description: {
      ca: "Aquesta rodeta modica l'afinació del pad seleccionat, o de tots si GROUP està activat."
    }
  },
  padVolume: {
    label: {
      ca: "Vol"
    },
    title: {
      ca: "Volum del pad"
    },
    description: {
      ca: "Aquesta rodeta modifica el volum del pad seleccionat, o de tots si GROUP està activat."
    }
  },
  padPan: {
    label: {
      ca: "Pan"
    },
    title: {
      ca: "Panoramització del pad"
    },
    description: {
      ca: "Aquesta rodeta modifica la panoramització del pad seleccionat (o de tots si GROUP està activat). Fa que el so es senti més per l'esquerra o la dreta."
    }
  },
  padReverse: {
    label: {
      ca: "Reverse"
    },
    title: {
      ca: "Reverse del pad"
    },
    description: {
      ca: "Si està activat, el sample és reprodueixi del final a l'inici, a l'inrevés."
    }
  },
  padAttack: {
    label: {
      ca: "Attack"
    },
    title: {
      ca: "Attack"
    },
    description: {
      ca: "El paràmetre attack modifica com comença a reproduir-se la mostra. Pot començar més bruscament o més suau, depenent d'on col·loquis l'angle del potenciòmetre."
    }
  },
  padRelease: {
    label: {
      ca: "Release"
    },
    title: {
      ca: "Release"
    },
    description: {
      ca: "El release és el temps que tarda el so a desaparèixer quan deixes anar la tecla. Pot fer que el so s'acabi de cop o s'esvaeixi suaument."
    }
  },
  padSlicer: {
    title: {
      ca: "Barra de tall"
    },
    description: {
      ca: "Marca els extrems del tall de la mostra del pad"
    }
  },
  padWaveformDisplay: {
    title: {
      ca: "Mostra"
    },
    description: {
      ca: "Aquí tens una representació gràfica de la mostra de so carregada al sampler. En el dibuix pots veure representades les diferents intensitats del so."
    }
  },
  padGrid: {
    title: {
      ca: "Pads"
    },
    description: {
      ca: "Cada pad reprodueix un fragment de la mostra carregada en el sampler."
    }
  },
  padsGroupToggle: {
    label: {
      ca: "GROUP"
    },
    title: {
      ca: "Group"
    },
    description: {
      ca: "Activant aquest botó fas que els paràmetres que modifiques (Pan, Vol o Pitch) afectin a tots els pads. Desactivat, les modificacions afecten solament al pad seleccionat."
    }
  },
  // ELEMENTS ESPECÍFICS, LOOPER
  looperTranspose: {
    label: {
      ca: "Transpose"
    }
  },
  looperSpeed: {
    label: {
      ca: "Speed"
    }
  },
  looperReverse: {
    label: {
      ca: "Reverse"
    }
  },
  // EFECTES
  fxWet: {
    label: {
      ca: "Wet"
    }
  },
  fxDistortionAmount: {
    label: {
      ca: "Drive"
    }
  },
  delayTime: {
    label: {
      ca: "Time"
    }
  },
  delayFeedback: {
    label: {
      ca: "Feedback"
    }
  },
  reverbDecay: {
    label: {
      ca: "Decay"
    }
  },
  djfValue: {
    label: {
      ca: "Value"
    }
  },
  djfQ: {
    label: {
      ca: "Q"
    }
  }
}